import { Component, Directive, Input, ChangeDetectionStrategy, ViewEncapsulation, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'class' : 'toolbar' }
})
export class ToolbarComponent {
  @Input() inverted:boolean;
  @Input() title: string;
  @Input() logo = true;
  @Input() color: string;
  @Input() logoLinked = true;

  constructor(private route: ActivatedRoute, private router: Router) {}
}

@Component({
  selector: 'app-toolbar-menu',
  templateUrl: './toolbar-menu.component.html',
  styleUrls: ['./toolbar-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarMenuComponent {}

@Component({
  selector: 'app-toolbar-close',
  templateUrl: './toolbar-close.component.html',
  styleUrls: ['./toolbar-close.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarCloseComponent {
  @Output("onClose")
  onClose = new EventEmitter();

  close() {
    this.onClose.emit(null);
  }
}

@Component({
  selector: 'app-toolbar-back',
  templateUrl: './toolbar-back.component.html',
  styleUrls: ['./toolbar-back.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarBackComponent {
  @Output("onBack")
  onBack = new EventEmitter();

  close() {
    this.onBack.emit(null);
  }  
}